import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

const Input = ({ onChange, ...props }) => <TextField fullWidth onChange={(e) => onChange(e.target.value)} {...props} />;

Input.propTypes = {
  onChange: PropTypes.func,
};

Input.defaultProps = {
  onChange: () => {},
};

export default Input;
